/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { FittingTreeViewService } from '../../../../../utils/src/lib/fitting-tree-view.service';
import { FittingTreeViewComponent } from '../../components/add-fitting-tab/fitting-tree-view/fitting-tree-view.component';
import { Observable } from 'rxjs';
import { IAddFittingModeFacade } from '../../../../../data-access/src/lib/domain/facades-models/add-fitting-mode-facade-interface';
import { FittingTreeView } from '../../models/fitting-tree-view-vm';
import { getTreeViewItem } from '../../../../../utils/src/lib/file-folder.utils';
import { LocalStorageService } from '../../../../../utils/src/lib/local-storage/local-storage.service';
import { DataInitializerService } from '../../../../../utils/src/lib/sysque-backend/data-initializer.service';
import { SystemInfo } from '../../../../../data-access/src/lib/domain/system-info';
import { TabDescription } from '../../../../../data-access/src/lib/domain/tab-description';
import { PastedItemsInfo } from '../../models/pasted-items-info';
import { GlobalConstants } from '../../constants/global-constants';
import { DotNetRequestMessageService } from '@mep/web-browser-bridge';

@Injectable({ providedIn: 'root' })
export class AddFittingModeFacade implements IAddFittingModeFacade {
  constructor(
    public fittingTreeViewService: FittingTreeViewService,
    public localStorageService: LocalStorageService,
    public service: DataInitializerService,
    public messageHandler: DotNetRequestMessageService
  ) {}

  public getFittingTreeViewInstance(): Observable<FittingTreeViewComponent> {
    return this.fittingTreeViewService.fittingTreeView$;
  }

  public getTreeViewItem(treeViewDatasource: FittingTreeView[], itemFolderPath: string): FittingTreeView | null {
    return getTreeViewItem(treeViewDatasource, itemFolderPath);
  }

  public updateLocalStorage(key: string, value: any): void {
    this.localStorageService.updateStorage(key, value);
  }

  public updateSystemList(): Observable<SystemInfo[]> {
    return this.service.InitializeSystemInfo();
  }

  public getCategories(systemName: string): Observable<TabDescription[]> {
    return this.service.InitializeCategoryList(systemName);
  } 

  public executePasteItemsAction(replaceItems: PastedItemsInfo[]): void {
    this.messageHandler.sendRequestAsync(GlobalConstants.LogicToExecuteForPasteItems, [replaceItems]);
  }
}
